module.exports = {
	"contractName": "Token",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sharesOwnedAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sharesCitizensAddress",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "sell",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "sellPrice",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "target",
					"type": "address"
				},
				{
					"name": "mintedAmount",
					"type": "uint256"
				}
			],
			"name": "mintToken",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "buyPrice",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				}
			],
			"name": "getBalanceOf",
			"outputs": [
				{
					"name": "balance",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newSellPrice",
					"type": "uint256"
				}
			],
			"name": "setPrices",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "buy",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "frozenAccount",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "target",
					"type": "address"
				},
				{
					"name": "freeze",
					"type": "bool"
				}
			],
			"name": "freezeAccount",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "ownedAddress",
					"type": "address"
				},
				{
					"name": "citizensAddress",
					"type": "address"
				},
				{
					"name": "initialSupply",
					"type": "uint256"
				},
				{
					"name": "tokenName",
					"type": "string"
				},
				{
					"name": "tokenSymbol",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "from",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "target",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "frozen",
					"type": "bool"
				}
			],
			"name": "FrozenFunds",
			"type": "event"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "241:5155:4:-;;;383:1;359:25;;;;;;;;;;;;;;;;;;;;1407:711;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1627:12;1600:18;;:40;;;;;;;;;;;;;;;;;;1684:15;1651:21;;:49;;;;;;;;;;;;;;;;;;1755:8;;;;;;;;;;;1747:17;;1741:2;:23;1725:13;:39;1711:11;:53;;;;1847:11;;1823:9;:21;1833:10;1823:21;;;;;;;;;;;;;;;:35;;;;1930:9;1923:4;:16;;;;;;;;;;;;:::i;:::-;;2030:11;2021:6;:20;;;;;;;;;;;;:::i;:::-;;1407:711;;;;;241:5155;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "241:5155:4:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;307:18;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;485:31:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;391:26;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;359:25;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;523:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4983:404;;;;;;;;;;;;;;424:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;670:45;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3393:318;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;455:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;332:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3000:177:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4331:148;;;;;;;;;;;;;;;;;;;;;;;;;;4564:343;;;;;;569:46;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3912:221;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;307:18;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;485:31::-;;;;;;;;;;;;;:::o;391:26::-;;;;:::o;359:25::-;;;;;;;;;;;;;:::o;523:37::-;;;;;;;;;;;;;:::o;4983:404::-;1232:1;1184:21;;;;;;;;;;;:32;;;1217:10;1184:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:49;;1176:58;;;;;;;;5054:1;5029:9;:21;5039:10;5029:21;;;;;;;;;;;;;;;;:26;:62;;;;;5082:9;;5066:4;:12;;;:25;;5029:62;5021:71;;;;;;;;5160:55;5170:10;5182:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5213:1;5160:9;:55::i;:::-;5252:10;:19;;:30;5272:9;;5252:30;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4983:404::o;424:24::-;;;;:::o;670:45::-;;;;;;;;;;;;;;;;;:::o;3393:318::-;1084:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1070:43;;:10;:43;;;1062:52;;;;;;;;3530:1;3486:21;;;;;;;;;;;:32;;;3519:6;3486:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:45;;3478:54;;;;;;;;3564:12;3543:9;:17;3553:6;3543:17;;;;;;;;;;;;;;;;:33;;;;;;;;;;;3602:12;3587:11;;:27;;;;;;;;;;;3637:4;3625:31;;3634:1;3625:31;3643:12;3625:31;;;;;;;;;;;;;;;;;;3682:6;3667:36;;3676:4;3667:36;;;3690:12;3667:36;;;;;;;;;;;;;;;;;;3393:318;;:::o;455:23::-;;;;:::o;332:20::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;3000:177::-;3072:15;3099:20;3122:9;:17;3132:6;3122:17;;;;;;;;;;;;;;;;3099:40;;3157:12;3150:19;;3000:177;;;;:::o;4331:148::-;1084:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1070:43;;:10;:43;;;1062:52;;;;;;;;4412:12;4400:9;:24;;;;4470:1;4458:9;;:13;;;;;;;;4446:9;;:25;4435:8;:36;;;;4331:148;:::o;4564:343::-;4698:15;1232:1;1184:21;;;;;;;;;;;:32;;;1217:10;1184:44;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:49;;1176:58;;;;;;;;4647:1;4623:9;:21;4633:10;4623:21;;;;;;;;;;;;;;;;:25;:63;;;;;4678:8;;4665:9;:21;4623:63;4615:72;;;;;;;;4727:9;;4716:8;;:20;4698:38;;4747:55;4757:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4788:10;4800:1;4747:9;:55::i;:::-;4849:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:38;;:50;4888:10;4849:50;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4564:343;:::o;569:46::-;;;;;;;;;;;;;;;;;;;;;;:::o;3912:221::-;1084:18;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1070:43;;:10;:43;;;1062:52;;;;;;;;4044:1;4000:21;;;;;;;;;;;:32;;;4033:6;4000:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:45;;3992:54;;;;;;;;4081:6;4057:13;:21;4071:6;4057:21;;;;;;;;;;;;;;;;:30;;;;;;;;;;;;;;;;;;4098:27;4110:6;4118;4098:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3912:221;;:::o;2209:779::-;2305:3;2298;:10;;;;:140;;;;;2432:6;2412:9;:16;2422:5;2412:16;;;;;;;;;;;;;;;;:26;;2298:140;:249;;;;;2533:9;:14;2543:3;2533:14;;;;;;;;;;;;;;;;2524:6;2507:9;:14;2517:3;2507:14;;;;;;;;;;;;;;;;:23;:40;2298:249;:314;;;;;2592:13;:20;2606:5;2592:20;;;;;;;;;;;;;;;;;;;;;;;;;2591:21;2298:314;:402;;;;;2682:13;:18;2696:3;2682:18;;;;;;;;;;;;;;;;;;;;;;;;;2681:19;2298:402;2289:412;;;;;;;;2789:6;2769:9;:16;2779:5;2769:16;;;;;;;;;;;;;;;;:26;;;;;;;;;;;2876:6;2858:9;:14;2868:3;2858:14;;;;;;;;;;;;;;;;:24;;;;;;;;;;;2968:3;2952:28;;2961:5;2952:28;;;2973:6;2952:28;;;;;;;;;;;;;;;;;;2209:779;;;:::o",
	"source": "pragma solidity ^0.4.16;\r\n\r\ninterface Owned {\r\n    function getOwner() constant external returns (address contractOwner);\r\n}\r\n\r\ninterface Citizens {\r\n    function getCitizen(address _citizen) constant external returns(uint citizenId);\r\n}\r\n\r\ncontract Token {\r\n    \r\n    // Public variables of the token\r\n    string public name;\r\n    string public symbol;\r\n    uint8 public decimals = 0;\r\n    uint256 public totalSupply;\r\n    uint256 public sellPrice;\r\n    uint256 public buyPrice;\r\n    Owned public sharesOwnedAddress;\r\n    Citizens public sharesCitizensAddress;\r\n\r\n    mapping (address => bool) public frozenAccount;\r\n    // This creates an array with all balances\r\n    mapping (address => uint256) public balanceOf;\r\n\r\n    // This generates a public event on the blockchain that will notify clients\r\n    event Transfer(address indexed from, address indexed to, uint256 value);\r\n    \r\n    /* This generates a public event on the blockchain that will notify clients */\r\n    event FrozenFunds(address target, bool frozen);\r\n    \r\n    modifier onlyOwner {\r\n        require(msg.sender == sharesOwnedAddress.getOwner());\r\n        _;\r\n    }\r\n    \r\n    modifier isCitizen {\r\n        require(sharesCitizensAddress.getCitizen(msg.sender) != 0);\r\n        _;\r\n    }\r\n    \r\n    /**\r\n     * Constrctor function\r\n     *\r\n     * Initializes contract with initial supply tokens to the creator of the contract\r\n     */\r\n    function Token(\r\n        Owned ownedAddress, \r\n        Citizens citizensAddress,\r\n        uint256 initialSupply,\r\n        string tokenName,\r\n        string tokenSymbol\r\n    ) public {\r\n        sharesOwnedAddress = Owned(ownedAddress);\r\n        sharesCitizensAddress = Citizens(citizensAddress);\r\n        totalSupply = initialSupply * 10 ** uint256(decimals);  // Update total supply with the decimal amount\r\n        balanceOf[msg.sender] = totalSupply;                // Give the creator all initial tokens\r\n        name = tokenName;                                   // Set the name for display purposes\r\n        symbol = tokenSymbol;                               // Set the symbol for display purposes\r\n    }\r\n\r\n    /** \r\n     * Internal transfer, only can be called by this contract \r\n     */\r\n    function _transfer(address _from, address _to, uint _value) internal {\r\n        require (_to != 0x0                                 // Prevent transfer to 0x0 address. Use burn() instead\r\n            && balanceOf[_from] >= _value                   // Check if the sender has enough\r\n            && balanceOf[_to] + _value > balanceOf[_to]     // Check for overflows\r\n            && !frozenAccount[_from]                        // Check if sender is frozen\r\n            && !frozenAccount[_to]);                        // Check if recipient is frozen  \r\n        balanceOf[_from] -= _value;                         // Subtract from the sender\r\n        balanceOf[_to] += _value;                           // Add the same to the recipient\r\n        Transfer(_from, _to, _value);\r\n    }\r\n    \r\n    function getBalanceOf(address _owner) constant public \r\n        returns(uint256 balance){\r\n        uint256 ownerBalance = balanceOf[_owner];\r\n        return ownerBalance;\r\n    }\r\n    \r\n    /**\r\n     * @notice Create `mintedAmount` tokens and send it to `target`\r\n     * @param target Address to receive the tokens\r\n     * @param mintedAmount the amount of tokens it will receive\r\n     */\r\n    function mintToken(address target, uint256 mintedAmount) onlyOwner public {\r\n        require(sharesCitizensAddress.getCitizen(target) != 0);\r\n        balanceOf[target] += mintedAmount;\r\n        totalSupply += mintedAmount;\r\n        Transfer(0, this, mintedAmount);\r\n        Transfer(this, target, mintedAmount);\r\n    }\r\n\r\n    /**\r\n     * @notice `freeze? Prevent | Allow` `target` from sending & receiving tokens\r\n     * @param target Address to be frozen\r\n     * @param freeze either to freeze it or not\r\n     */\r\n    function freezeAccount(address target, bool freeze) onlyOwner public {\r\n        require(sharesCitizensAddress.getCitizen(target) != 0);\r\n        frozenAccount[target] = freeze;\r\n        FrozenFunds(target, freeze);\r\n    }\r\n\r\n    /**\r\n     * @notice Allow users to buy tokens for `newBuyPrice` eth and sell tokens for `newSellPrice` eth\r\n     * @param newSellPrice Price the users can sell to the contract\r\n     */\r\n    function setPrices(uint256 newSellPrice) onlyOwner public {\r\n        sellPrice = newSellPrice;\r\n        buyPrice = sellPrice + sellPrice / 5;\r\n    }\r\n\r\n    /** \r\n     * @notice Buy tokens from contract by sending ether\r\n     */\r\n    function buy() payable isCitizen public {\r\n        require(balanceOf[msg.sender] < 1\r\n            && msg.value == buyPrice);\r\n        uint commission = buyPrice - sellPrice;\r\n        _transfer(sharesOwnedAddress.getOwner(), msg.sender, 1);              // makes the transfers\r\n        sharesOwnedAddress.getOwner().transfer(commission);\r\n    }\r\n\r\n    /** \r\n     * @notice Sell `amount` tokens to contract\r\n     */\r\n    function sell() isCitizen public {\r\n\t\trequire(balanceOf[msg.sender] == 1\r\n\t\t    && this.balance >= sellPrice);        // checks if the contract has enough ether to buy\r\n        _transfer(msg.sender, sharesOwnedAddress.getOwner(), 1);    // makes the transfers\r\n        msg.sender.transfer(sellPrice);          // sends ether to the seller. It's important to do this last to avoid recursion attacks\r\n    }\r\n    \r\n}",
	"sourcePath": "C:\\Users\\nktpa\\Desktop\\truffle-react-auth\\contracts\\Token.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/C/Users/nktpa/Desktop/truffle-react-auth/contracts/Token.sol",
			"exportedSymbols": {
				"Citizens": [
					1017
				],
				"Owned": [
					1009
				],
				"Token": [
					1382
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 1003,
				"name": "PragmaDirective",
				"src": "0:24:4"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "interface",
					"documentation": null,
					"fullyImplemented": false,
					"linearizedBaseContracts": [
						1009
					],
					"name": "Owned",
					"scope": 1383
				},
				"children": [
					{
						"attributes": {
							"body": null,
							"constant": true,
							"implemented": false,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getOwner",
							"payable": false,
							"scope": 1009,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "external"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1004,
								"name": "ParameterList",
								"src": "68:2:4"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "contractOwner",
											"scope": 1008,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1005,
												"name": "ElementaryTypeName",
												"src": "98:7:4"
											}
										],
										"id": 1006,
										"name": "VariableDeclaration",
										"src": "98:21:4"
									}
								],
								"id": 1007,
								"name": "ParameterList",
								"src": "97:23:4"
							}
						],
						"id": 1008,
						"name": "FunctionDefinition",
						"src": "51:70:4"
					}
				],
				"id": 1009,
				"name": "ContractDefinition",
				"src": "28:96:4"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "interface",
					"documentation": null,
					"fullyImplemented": false,
					"linearizedBaseContracts": [
						1017
					],
					"name": "Citizens",
					"scope": 1383
				},
				"children": [
					{
						"attributes": {
							"body": null,
							"constant": true,
							"implemented": false,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getCitizen",
							"payable": false,
							"scope": 1017,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "external"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_citizen",
											"scope": 1016,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1010,
												"name": "ElementaryTypeName",
												"src": "174:7:4"
											}
										],
										"id": 1011,
										"name": "VariableDeclaration",
										"src": "174:16:4"
									}
								],
								"id": 1012,
								"name": "ParameterList",
								"src": "173:18:4"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "citizenId",
											"scope": 1016,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 1013,
												"name": "ElementaryTypeName",
												"src": "218:4:4"
											}
										],
										"id": 1014,
										"name": "VariableDeclaration",
										"src": "218:14:4"
									}
								],
								"id": 1015,
								"name": "ParameterList",
								"src": "217:16:4"
							}
						],
						"id": 1016,
						"name": "FunctionDefinition",
						"src": "154:80:4"
					}
				],
				"id": 1017,
				"name": "ContractDefinition",
				"src": "128:109:4"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						1382
					],
					"name": "Token",
					"scope": 1383
				},
				"children": [
					{
						"attributes": {
							"constant": false,
							"name": "name",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "string storage ref",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "string",
									"type": "string storage pointer"
								},
								"id": 1018,
								"name": "ElementaryTypeName",
								"src": "307:6:4"
							}
						],
						"id": 1019,
						"name": "VariableDeclaration",
						"src": "307:18:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "symbol",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "string storage ref",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "string",
									"type": "string storage pointer"
								},
								"id": 1020,
								"name": "ElementaryTypeName",
								"src": "332:6:4"
							}
						],
						"id": 1021,
						"name": "VariableDeclaration",
						"src": "332:20:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "decimals",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint8",
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint8",
									"type": "uint8"
								},
								"id": 1022,
								"name": "ElementaryTypeName",
								"src": "359:5:4"
							},
							{
								"attributes": {
									"argumentTypes": null,
									"hexvalue": "30",
									"isConstant": false,
									"isLValue": false,
									"isPure": true,
									"lValueRequested": false,
									"subdenomination": null,
									"token": "number",
									"type": "int_const 0",
									"value": "0"
								},
								"id": 1023,
								"name": "Literal",
								"src": "383:1:4"
							}
						],
						"id": 1024,
						"name": "VariableDeclaration",
						"src": "359:25:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "totalSupply",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1025,
								"name": "ElementaryTypeName",
								"src": "391:7:4"
							}
						],
						"id": 1026,
						"name": "VariableDeclaration",
						"src": "391:26:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sellPrice",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1027,
								"name": "ElementaryTypeName",
								"src": "424:7:4"
							}
						],
						"id": 1028,
						"name": "VariableDeclaration",
						"src": "424:24:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "buyPrice",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1029,
								"name": "ElementaryTypeName",
								"src": "455:7:4"
							}
						],
						"id": 1030,
						"name": "VariableDeclaration",
						"src": "455:23:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sharesOwnedAddress",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract Owned",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Owned",
									"referencedDeclaration": 1009,
									"type": "contract Owned"
								},
								"id": 1031,
								"name": "UserDefinedTypeName",
								"src": "485:5:4"
							}
						],
						"id": 1032,
						"name": "VariableDeclaration",
						"src": "485:31:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "sharesCitizensAddress",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract Citizens",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Citizens",
									"referencedDeclaration": 1017,
									"type": "contract Citizens"
								},
								"id": 1033,
								"name": "UserDefinedTypeName",
								"src": "523:8:4"
							}
						],
						"id": 1034,
						"name": "VariableDeclaration",
						"src": "523:37:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "frozenAccount",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => bool)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => bool)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1035,
										"name": "ElementaryTypeName",
										"src": "578:7:4"
									},
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 1036,
										"name": "ElementaryTypeName",
										"src": "589:4:4"
									}
								],
								"id": 1037,
								"name": "Mapping",
								"src": "569:25:4"
							}
						],
						"id": 1038,
						"name": "VariableDeclaration",
						"src": "569:46:4"
					},
					{
						"attributes": {
							"constant": false,
							"name": "balanceOf",
							"scope": 1382,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => uint256)",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => uint256)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1039,
										"name": "ElementaryTypeName",
										"src": "679:7:4"
									},
									{
										"attributes": {
											"name": "uint256",
											"type": "uint256"
										},
										"id": 1040,
										"name": "ElementaryTypeName",
										"src": "690:7:4"
									}
								],
								"id": 1041,
								"name": "Mapping",
								"src": "670:28:4"
							}
						],
						"id": 1042,
						"name": "VariableDeclaration",
						"src": "670:45:4"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "Transfer"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": true,
											"name": "from",
											"scope": 1050,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1043,
												"name": "ElementaryTypeName",
												"src": "820:7:4"
											}
										],
										"id": 1044,
										"name": "VariableDeclaration",
										"src": "820:20:4"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": true,
											"name": "to",
											"scope": 1050,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1045,
												"name": "ElementaryTypeName",
												"src": "842:7:4"
											}
										],
										"id": 1046,
										"name": "VariableDeclaration",
										"src": "842:18:4"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "value",
											"scope": 1050,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1047,
												"name": "ElementaryTypeName",
												"src": "862:7:4"
											}
										],
										"id": 1048,
										"name": "VariableDeclaration",
										"src": "862:13:4"
									}
								],
								"id": 1049,
								"name": "ParameterList",
								"src": "819:57:4"
							}
						],
						"id": 1050,
						"name": "EventDefinition",
						"src": "805:72:4"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "FrozenFunds"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "target",
											"scope": 1056,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1051,
												"name": "ElementaryTypeName",
												"src": "991:7:4"
											}
										],
										"id": 1052,
										"name": "VariableDeclaration",
										"src": "991:14:4"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "frozen",
											"scope": 1056,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 1053,
												"name": "ElementaryTypeName",
												"src": "1007:4:4"
											}
										],
										"id": 1054,
										"name": "VariableDeclaration",
										"src": "1007:11:4"
									}
								],
								"id": 1055,
								"name": "ParameterList",
								"src": "990:29:4"
							}
						],
						"id": 1056,
						"name": "EventDefinition",
						"src": "973:47:4"
					},
					{
						"attributes": {
							"name": "onlyOwner",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1057,
								"name": "ParameterList",
								"src": "1051:0:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1058,
														"name": "Identifier",
														"src": "1062:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "==",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1059,
																		"name": "Identifier",
																		"src": "1070:3:4"
																	}
																],
																"id": 1060,
																"name": "MemberAccess",
																"src": "1070:10:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"arguments": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "address",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				null
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getOwner",
																			"referencedDeclaration": 1008,
																			"type": "function () view external returns (address)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1032,
																					"type": "contract Owned",
																					"value": "sharesOwnedAddress"
																				},
																				"id": 1061,
																				"name": "Identifier",
																				"src": "1084:18:4"
																			}
																		],
																		"id": 1062,
																		"name": "MemberAccess",
																		"src": "1084:27:4"
																	}
																],
																"id": 1063,
																"name": "FunctionCall",
																"src": "1084:29:4"
															}
														],
														"id": 1064,
														"name": "BinaryOperation",
														"src": "1070:43:4"
													}
												],
												"id": 1065,
												"name": "FunctionCall",
												"src": "1062:52:4"
											}
										],
										"id": 1066,
										"name": "ExpressionStatement",
										"src": "1062:52:4"
									},
									{
										"id": 1067,
										"name": "PlaceholderStatement",
										"src": "1125:1:4"
									}
								],
								"id": 1068,
								"name": "Block",
								"src": "1051:83:4"
							}
						],
						"id": 1069,
						"name": "ModifierDefinition",
						"src": "1032:102:4"
					},
					{
						"attributes": {
							"name": "isCitizen",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1070,
								"name": "ParameterList",
								"src": "1165:0:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1071,
														"name": "Identifier",
														"src": "1176:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "!=",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "uint256",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getCitizen",
																			"referencedDeclaration": 1016,
																			"type": "function (address) view external returns (uint256)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1034,
																					"type": "contract Citizens",
																					"value": "sharesCitizensAddress"
																				},
																				"id": 1072,
																				"name": "Identifier",
																				"src": "1184:21:4"
																			}
																		],
																		"id": 1073,
																		"name": "MemberAccess",
																		"src": "1184:32:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "sender",
																			"referencedDeclaration": null,
																			"type": "address"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1394,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 1074,
																				"name": "Identifier",
																				"src": "1217:3:4"
																			}
																		],
																		"id": 1075,
																		"name": "MemberAccess",
																		"src": "1217:10:4"
																	}
																],
																"id": 1076,
																"name": "FunctionCall",
																"src": "1184:44:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 1077,
																"name": "Literal",
																"src": "1232:1:4"
															}
														],
														"id": 1078,
														"name": "BinaryOperation",
														"src": "1184:49:4"
													}
												],
												"id": 1079,
												"name": "FunctionCall",
												"src": "1176:58:4"
											}
										],
										"id": 1080,
										"name": "ExpressionStatement",
										"src": "1176:58:4"
									},
									{
										"id": 1081,
										"name": "PlaceholderStatement",
										"src": "1245:1:4"
									}
								],
								"id": 1082,
								"name": "Block",
								"src": "1165:89:4"
							}
						],
						"id": 1083,
						"name": "ModifierDefinition",
						"src": "1146:108:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "Token",
							"payable": false,
							"scope": 1382,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "ownedAddress",
											"scope": 1134,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "contract Owned",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Owned",
													"referencedDeclaration": 1009,
													"type": "contract Owned"
												},
												"id": 1084,
												"name": "UserDefinedTypeName",
												"src": "1432:5:4"
											}
										],
										"id": 1085,
										"name": "VariableDeclaration",
										"src": "1432:18:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "citizensAddress",
											"scope": 1134,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "contract Citizens",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"contractScope": null,
													"name": "Citizens",
													"referencedDeclaration": 1017,
													"type": "contract Citizens"
												},
												"id": 1086,
												"name": "UserDefinedTypeName",
												"src": "1462:8:4"
											}
										],
										"id": 1087,
										"name": "VariableDeclaration",
										"src": "1462:24:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "initialSupply",
											"scope": 1134,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1088,
												"name": "ElementaryTypeName",
												"src": "1497:7:4"
											}
										],
										"id": 1089,
										"name": "VariableDeclaration",
										"src": "1497:21:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "tokenName",
											"scope": 1134,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 1090,
												"name": "ElementaryTypeName",
												"src": "1529:6:4"
											}
										],
										"id": 1091,
										"name": "VariableDeclaration",
										"src": "1529:16:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "tokenSymbol",
											"scope": 1134,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 1092,
												"name": "ElementaryTypeName",
												"src": "1556:6:4"
											}
										],
										"id": 1093,
										"name": "VariableDeclaration",
										"src": "1556:18:4"
									}
								],
								"id": 1094,
								"name": "ParameterList",
								"src": "1421:160:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1095,
								"name": "ParameterList",
								"src": "1589:0:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract Owned"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1032,
															"type": "contract Owned",
															"value": "sharesOwnedAddress"
														},
														"id": 1096,
														"name": "Identifier",
														"src": "1600:18:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract Owned",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_contract$_Owned_$1009",
																			"typeString": "contract Owned"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1009,
																	"type": "type(contract Owned)",
																	"value": "Owned"
																},
																"id": 1097,
																"name": "Identifier",
																"src": "1621:5:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1085,
																	"type": "contract Owned",
																	"value": "ownedAddress"
																},
																"id": 1098,
																"name": "Identifier",
																"src": "1627:12:4"
															}
														],
														"id": 1099,
														"name": "FunctionCall",
														"src": "1621:19:4"
													}
												],
												"id": 1100,
												"name": "Assignment",
												"src": "1600:40:4"
											}
										],
										"id": 1101,
										"name": "ExpressionStatement",
										"src": "1600:40:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract Citizens"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1034,
															"type": "contract Citizens",
															"value": "sharesCitizensAddress"
														},
														"id": 1102,
														"name": "Identifier",
														"src": "1651:21:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract Citizens",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_contract$_Citizens_$1017",
																			"typeString": "contract Citizens"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1017,
																	"type": "type(contract Citizens)",
																	"value": "Citizens"
																},
																"id": 1103,
																"name": "Identifier",
																"src": "1675:8:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1087,
																	"type": "contract Citizens",
																	"value": "citizensAddress"
																},
																"id": 1104,
																"name": "Identifier",
																"src": "1684:15:4"
															}
														],
														"id": 1105,
														"name": "FunctionCall",
														"src": "1675:25:4"
													}
												],
												"id": 1106,
												"name": "Assignment",
												"src": "1651:49:4"
											}
										],
										"id": 1107,
										"name": "ExpressionStatement",
										"src": "1651:49:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1026,
															"type": "uint256",
															"value": "totalSupply"
														},
														"id": 1108,
														"name": "Identifier",
														"src": "1711:11:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "*",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1089,
																	"type": "uint256",
																	"value": "initialSupply"
																},
																"id": 1109,
																"name": "Identifier",
																"src": "1725:13:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "**",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3130",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 10",
																			"value": "10"
																		},
																		"id": 1110,
																		"name": "Literal",
																		"src": "1741:2:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"isStructConstructorCall": false,
																			"lValueRequested": false,
																			"names": [
																				null
																			],
																			"type": "uint256",
																			"type_conversion": true
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": [
																						{
																							"typeIdentifier": "t_uint8",
																							"typeString": "uint8"
																						}
																					],
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"type": "type(uint256)",
																					"value": "uint256"
																				},
																				"id": 1111,
																				"name": "ElementaryTypeNameExpression",
																				"src": "1747:7:4"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1024,
																					"type": "uint8",
																					"value": "decimals"
																				},
																				"id": 1112,
																				"name": "Identifier",
																				"src": "1755:8:4"
																			}
																		],
																		"id": 1113,
																		"name": "FunctionCall",
																		"src": "1747:17:4"
																	}
																],
																"id": 1114,
																"name": "BinaryOperation",
																"src": "1741:23:4"
															}
														],
														"id": 1115,
														"name": "BinaryOperation",
														"src": "1725:39:4"
													}
												],
												"id": 1116,
												"name": "Assignment",
												"src": "1711:53:4"
											}
										],
										"id": 1117,
										"name": "ExpressionStatement",
										"src": "1711:53:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1042,
																	"type": "mapping(address => uint256)",
																	"value": "balanceOf"
																},
																"id": 1118,
																"name": "Identifier",
																"src": "1823:9:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1119,
																		"name": "Identifier",
																		"src": "1833:3:4"
																	}
																],
																"id": 1120,
																"name": "MemberAccess",
																"src": "1833:10:4"
															}
														],
														"id": 1121,
														"name": "IndexAccess",
														"src": "1823:21:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1026,
															"type": "uint256",
															"value": "totalSupply"
														},
														"id": 1122,
														"name": "Identifier",
														"src": "1847:11:4"
													}
												],
												"id": 1123,
												"name": "Assignment",
												"src": "1823:35:4"
											}
										],
										"id": 1124,
										"name": "ExpressionStatement",
										"src": "1823:35:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "string storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1019,
															"type": "string storage ref",
															"value": "name"
														},
														"id": 1125,
														"name": "Identifier",
														"src": "1923:4:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1091,
															"type": "string memory",
															"value": "tokenName"
														},
														"id": 1126,
														"name": "Identifier",
														"src": "1930:9:4"
													}
												],
												"id": 1127,
												"name": "Assignment",
												"src": "1923:16:4"
											}
										],
										"id": 1128,
										"name": "ExpressionStatement",
										"src": "1923:16:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "string storage ref"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1021,
															"type": "string storage ref",
															"value": "symbol"
														},
														"id": 1129,
														"name": "Identifier",
														"src": "2021:6:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1093,
															"type": "string memory",
															"value": "tokenSymbol"
														},
														"id": 1130,
														"name": "Identifier",
														"src": "2030:11:4"
													}
												],
												"id": 1131,
												"name": "Assignment",
												"src": "2021:20:4"
											}
										],
										"id": 1132,
										"name": "ExpressionStatement",
										"src": "2021:20:4"
									}
								],
								"id": 1133,
								"name": "Block",
								"src": "1589:529:4"
							}
						],
						"id": 1134,
						"name": "FunctionDefinition",
						"src": "1407:711:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "_transfer",
							"payable": false,
							"scope": 1382,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "internal"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_from",
											"scope": 1194,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1135,
												"name": "ElementaryTypeName",
												"src": "2228:7:4"
											}
										],
										"id": 1136,
										"name": "VariableDeclaration",
										"src": "2228:13:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_to",
											"scope": 1194,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1137,
												"name": "ElementaryTypeName",
												"src": "2243:7:4"
											}
										],
										"id": 1138,
										"name": "VariableDeclaration",
										"src": "2243:11:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_value",
											"scope": 1194,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint",
													"type": "uint256"
												},
												"id": 1139,
												"name": "ElementaryTypeName",
												"src": "2256:4:4"
											}
										],
										"id": 1140,
										"name": "VariableDeclaration",
										"src": "2256:11:4"
									}
								],
								"id": 1141,
								"name": "ParameterList",
								"src": "2227:41:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1142,
								"name": "ParameterList",
								"src": "2278:0:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1143,
														"name": "Identifier",
														"src": "2289:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "&&",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "&&",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_bool",
																						"typeString": "bool"
																					},
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"operator": "&&",
																					"type": "bool"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"commonType": {
																								"typeIdentifier": "t_address",
																								"typeString": "address"
																							},
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"operator": "!=",
																							"type": "bool"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1138,
																									"type": "address",
																									"value": "_to"
																								},
																								"id": 1144,
																								"name": "Identifier",
																								"src": "2298:3:4"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"hexvalue": "307830",
																									"isConstant": false,
																									"isLValue": false,
																									"isPure": true,
																									"lValueRequested": false,
																									"subdenomination": null,
																									"token": "number",
																									"type": "int_const 0",
																									"value": "0x0"
																								},
																								"id": 1145,
																								"name": "Literal",
																								"src": "2305:3:4"
																							}
																						],
																						"id": 1146,
																						"name": "BinaryOperation",
																						"src": "2298:10:4"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"commonType": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							},
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"operator": ">=",
																							"type": "bool"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"isConstant": false,
																									"isLValue": true,
																									"isPure": false,
																									"lValueRequested": false,
																									"type": "uint256"
																								},
																								"children": [
																									{
																										"attributes": {
																											"argumentTypes": null,
																											"overloadedDeclarations": [
																												null
																											],
																											"referencedDeclaration": 1042,
																											"type": "mapping(address => uint256)",
																											"value": "balanceOf"
																										},
																										"id": 1147,
																										"name": "Identifier",
																										"src": "2412:9:4"
																									},
																									{
																										"attributes": {
																											"argumentTypes": null,
																											"overloadedDeclarations": [
																												null
																											],
																											"referencedDeclaration": 1136,
																											"type": "address",
																											"value": "_from"
																										},
																										"id": 1148,
																										"name": "Identifier",
																										"src": "2422:5:4"
																									}
																								],
																								"id": 1149,
																								"name": "IndexAccess",
																								"src": "2412:16:4"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1140,
																									"type": "uint256",
																									"value": "_value"
																								},
																								"id": 1150,
																								"name": "Identifier",
																								"src": "2432:6:4"
																							}
																						],
																						"id": 1151,
																						"name": "BinaryOperation",
																						"src": "2412:26:4"
																					}
																				],
																				"id": 1152,
																				"name": "BinaryOperation",
																				"src": "2298:140:4"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint256",
																						"typeString": "uint256"
																					},
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"operator": ">",
																					"type": "bool"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"commonType": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							},
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"operator": "+",
																							"type": "uint256"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"isConstant": false,
																									"isLValue": true,
																									"isPure": false,
																									"lValueRequested": false,
																									"type": "uint256"
																								},
																								"children": [
																									{
																										"attributes": {
																											"argumentTypes": null,
																											"overloadedDeclarations": [
																												null
																											],
																											"referencedDeclaration": 1042,
																											"type": "mapping(address => uint256)",
																											"value": "balanceOf"
																										},
																										"id": 1153,
																										"name": "Identifier",
																										"src": "2507:9:4"
																									},
																									{
																										"attributes": {
																											"argumentTypes": null,
																											"overloadedDeclarations": [
																												null
																											],
																											"referencedDeclaration": 1138,
																											"type": "address",
																											"value": "_to"
																										},
																										"id": 1154,
																										"name": "Identifier",
																										"src": "2517:3:4"
																									}
																								],
																								"id": 1155,
																								"name": "IndexAccess",
																								"src": "2507:14:4"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1140,
																									"type": "uint256",
																									"value": "_value"
																								},
																								"id": 1156,
																								"name": "Identifier",
																								"src": "2524:6:4"
																							}
																						],
																						"id": 1157,
																						"name": "BinaryOperation",
																						"src": "2507:23:4"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"type": "uint256"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1042,
																									"type": "mapping(address => uint256)",
																									"value": "balanceOf"
																								},
																								"id": 1158,
																								"name": "Identifier",
																								"src": "2533:9:4"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1138,
																									"type": "address",
																									"value": "_to"
																								},
																								"id": 1159,
																								"name": "Identifier",
																								"src": "2543:3:4"
																							}
																						],
																						"id": 1160,
																						"name": "IndexAccess",
																						"src": "2533:14:4"
																					}
																				],
																				"id": 1161,
																				"name": "BinaryOperation",
																				"src": "2507:40:4"
																			}
																		],
																		"id": 1162,
																		"name": "BinaryOperation",
																		"src": "2298:249:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "!",
																			"prefix": true,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"type": "bool"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1038,
																							"type": "mapping(address => bool)",
																							"value": "frozenAccount"
																						},
																						"id": 1163,
																						"name": "Identifier",
																						"src": "2592:13:4"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1136,
																							"type": "address",
																							"value": "_from"
																						},
																						"id": 1164,
																						"name": "Identifier",
																						"src": "2606:5:4"
																					}
																				],
																				"id": 1165,
																				"name": "IndexAccess",
																				"src": "2592:20:4"
																			}
																		],
																		"id": 1166,
																		"name": "UnaryOperation",
																		"src": "2591:21:4"
																	}
																],
																"id": 1167,
																"name": "BinaryOperation",
																"src": "2298:314:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!",
																	"prefix": true,
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1038,
																					"type": "mapping(address => bool)",
																					"value": "frozenAccount"
																				},
																				"id": 1168,
																				"name": "Identifier",
																				"src": "2682:13:4"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1138,
																					"type": "address",
																					"value": "_to"
																				},
																				"id": 1169,
																				"name": "Identifier",
																				"src": "2696:3:4"
																			}
																		],
																		"id": 1170,
																		"name": "IndexAccess",
																		"src": "2682:18:4"
																	}
																],
																"id": 1171,
																"name": "UnaryOperation",
																"src": "2681:19:4"
															}
														],
														"id": 1172,
														"name": "BinaryOperation",
														"src": "2298:402:4"
													}
												],
												"id": 1173,
												"name": "FunctionCall",
												"src": "2289:412:4"
											}
										],
										"id": 1174,
										"name": "ExpressionStatement",
										"src": "2289:412:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "-=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1042,
																	"type": "mapping(address => uint256)",
																	"value": "balanceOf"
																},
																"id": 1175,
																"name": "Identifier",
																"src": "2769:9:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1136,
																	"type": "address",
																	"value": "_from"
																},
																"id": 1176,
																"name": "Identifier",
																"src": "2779:5:4"
															}
														],
														"id": 1177,
														"name": "IndexAccess",
														"src": "2769:16:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1140,
															"type": "uint256",
															"value": "_value"
														},
														"id": 1178,
														"name": "Identifier",
														"src": "2789:6:4"
													}
												],
												"id": 1179,
												"name": "Assignment",
												"src": "2769:26:4"
											}
										],
										"id": 1180,
										"name": "ExpressionStatement",
										"src": "2769:26:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1042,
																	"type": "mapping(address => uint256)",
																	"value": "balanceOf"
																},
																"id": 1181,
																"name": "Identifier",
																"src": "2858:9:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1138,
																	"type": "address",
																	"value": "_to"
																},
																"id": 1182,
																"name": "Identifier",
																"src": "2868:3:4"
															}
														],
														"id": 1183,
														"name": "IndexAccess",
														"src": "2858:14:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1140,
															"type": "uint256",
															"value": "_value"
														},
														"id": 1184,
														"name": "Identifier",
														"src": "2876:6:4"
													}
												],
												"id": 1185,
												"name": "Assignment",
												"src": "2858:24:4"
											}
										],
										"id": 1186,
										"name": "ExpressionStatement",
										"src": "2858:24:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1050,
															"type": "function (address,address,uint256)",
															"value": "Transfer"
														},
														"id": 1187,
														"name": "Identifier",
														"src": "2952:8:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1136,
															"type": "address",
															"value": "_from"
														},
														"id": 1188,
														"name": "Identifier",
														"src": "2961:5:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1138,
															"type": "address",
															"value": "_to"
														},
														"id": 1189,
														"name": "Identifier",
														"src": "2968:3:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1140,
															"type": "uint256",
															"value": "_value"
														},
														"id": 1190,
														"name": "Identifier",
														"src": "2973:6:4"
													}
												],
												"id": 1191,
												"name": "FunctionCall",
												"src": "2952:28:4"
											}
										],
										"id": 1192,
										"name": "ExpressionStatement",
										"src": "2952:28:4"
									}
								],
								"id": 1193,
								"name": "Block",
								"src": "2278:710:4"
							}
						],
						"id": 1194,
						"name": "FunctionDefinition",
						"src": "2209:779:4"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getBalanceOf",
							"payable": false,
							"scope": 1382,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_owner",
											"scope": 1210,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1195,
												"name": "ElementaryTypeName",
												"src": "3022:7:4"
											}
										],
										"id": 1196,
										"name": "VariableDeclaration",
										"src": "3022:14:4"
									}
								],
								"id": 1197,
								"name": "ParameterList",
								"src": "3021:16:4"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "balance",
											"scope": 1210,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1198,
												"name": "ElementaryTypeName",
												"src": "3072:7:4"
											}
										],
										"id": 1199,
										"name": "VariableDeclaration",
										"src": "3072:15:4"
									}
								],
								"id": 1200,
								"name": "ParameterList",
								"src": "3071:17:4"
							},
							{
								"children": [
									{
										"attributes": {
											"assignments": [
												1202
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "ownerBalance",
													"scope": 1210,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint256",
															"type": "uint256"
														},
														"id": 1201,
														"name": "ElementaryTypeName",
														"src": "3099:7:4"
													}
												],
												"id": 1202,
												"name": "VariableDeclaration",
												"src": "3099:20:4"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1042,
															"type": "mapping(address => uint256)",
															"value": "balanceOf"
														},
														"id": 1203,
														"name": "Identifier",
														"src": "3122:9:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1196,
															"type": "address",
															"value": "_owner"
														},
														"id": 1204,
														"name": "Identifier",
														"src": "3132:6:4"
													}
												],
												"id": 1205,
												"name": "IndexAccess",
												"src": "3122:17:4"
											}
										],
										"id": 1206,
										"name": "VariableDeclarationStatement",
										"src": "3099:40:4"
									},
									{
										"attributes": {
											"functionReturnParameters": 1200
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"overloadedDeclarations": [
														null
													],
													"referencedDeclaration": 1202,
													"type": "uint256",
													"value": "ownerBalance"
												},
												"id": 1207,
												"name": "Identifier",
												"src": "3157:12:4"
											}
										],
										"id": 1208,
										"name": "Return",
										"src": "3150:19:4"
									}
								],
								"id": 1209,
								"name": "Block",
								"src": "3088:89:4"
							}
						],
						"id": 1210,
						"name": "FunctionDefinition",
						"src": "3000:177:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "mintToken",
							"payable": false,
							"scope": 1382,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "target",
											"scope": 1251,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1211,
												"name": "ElementaryTypeName",
												"src": "3412:7:4"
											}
										],
										"id": 1212,
										"name": "VariableDeclaration",
										"src": "3412:14:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "mintedAmount",
											"scope": 1251,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1213,
												"name": "ElementaryTypeName",
												"src": "3428:7:4"
											}
										],
										"id": 1214,
										"name": "VariableDeclaration",
										"src": "3428:20:4"
									}
								],
								"id": 1215,
								"name": "ParameterList",
								"src": "3411:38:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1218,
								"name": "ParameterList",
								"src": "3467:0:4"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1069,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 1216,
										"name": "Identifier",
										"src": "3450:9:4"
									}
								],
								"id": 1217,
								"name": "ModifierInvocation",
								"src": "3450:9:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1219,
														"name": "Identifier",
														"src": "3478:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "!=",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "uint256",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getCitizen",
																			"referencedDeclaration": 1016,
																			"type": "function (address) view external returns (uint256)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1034,
																					"type": "contract Citizens",
																					"value": "sharesCitizensAddress"
																				},
																				"id": 1220,
																				"name": "Identifier",
																				"src": "3486:21:4"
																			}
																		],
																		"id": 1221,
																		"name": "MemberAccess",
																		"src": "3486:32:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1212,
																			"type": "address",
																			"value": "target"
																		},
																		"id": 1222,
																		"name": "Identifier",
																		"src": "3519:6:4"
																	}
																],
																"id": 1223,
																"name": "FunctionCall",
																"src": "3486:40:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 1224,
																"name": "Literal",
																"src": "3530:1:4"
															}
														],
														"id": 1225,
														"name": "BinaryOperation",
														"src": "3486:45:4"
													}
												],
												"id": 1226,
												"name": "FunctionCall",
												"src": "3478:54:4"
											}
										],
										"id": 1227,
										"name": "ExpressionStatement",
										"src": "3478:54:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1042,
																	"type": "mapping(address => uint256)",
																	"value": "balanceOf"
																},
																"id": 1228,
																"name": "Identifier",
																"src": "3543:9:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1212,
																	"type": "address",
																	"value": "target"
																},
																"id": 1229,
																"name": "Identifier",
																"src": "3553:6:4"
															}
														],
														"id": 1230,
														"name": "IndexAccess",
														"src": "3543:17:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1214,
															"type": "uint256",
															"value": "mintedAmount"
														},
														"id": 1231,
														"name": "Identifier",
														"src": "3564:12:4"
													}
												],
												"id": 1232,
												"name": "Assignment",
												"src": "3543:33:4"
											}
										],
										"id": 1233,
										"name": "ExpressionStatement",
										"src": "3543:33:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "+=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1026,
															"type": "uint256",
															"value": "totalSupply"
														},
														"id": 1234,
														"name": "Identifier",
														"src": "3587:11:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1214,
															"type": "uint256",
															"value": "mintedAmount"
														},
														"id": 1235,
														"name": "Identifier",
														"src": "3602:12:4"
													}
												],
												"id": 1236,
												"name": "Assignment",
												"src": "3587:27:4"
											}
										],
										"id": 1237,
										"name": "ExpressionStatement",
										"src": "3587:27:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																{
																	"typeIdentifier": "t_contract$_Token_$1382",
																	"typeString": "contract Token"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1050,
															"type": "function (address,address,uint256)",
															"value": "Transfer"
														},
														"id": 1238,
														"name": "Identifier",
														"src": "3625:8:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 1239,
														"name": "Literal",
														"src": "3634:1:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1425,
															"type": "contract Token",
															"value": "this"
														},
														"id": 1240,
														"name": "Identifier",
														"src": "3637:4:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1214,
															"type": "uint256",
															"value": "mintedAmount"
														},
														"id": 1241,
														"name": "Identifier",
														"src": "3643:12:4"
													}
												],
												"id": 1242,
												"name": "FunctionCall",
												"src": "3625:31:4"
											}
										],
										"id": 1243,
										"name": "ExpressionStatement",
										"src": "3625:31:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_contract$_Token_$1382",
																	"typeString": "contract Token"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1050,
															"type": "function (address,address,uint256)",
															"value": "Transfer"
														},
														"id": 1244,
														"name": "Identifier",
														"src": "3667:8:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1425,
															"type": "contract Token",
															"value": "this"
														},
														"id": 1245,
														"name": "Identifier",
														"src": "3676:4:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1212,
															"type": "address",
															"value": "target"
														},
														"id": 1246,
														"name": "Identifier",
														"src": "3682:6:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1214,
															"type": "uint256",
															"value": "mintedAmount"
														},
														"id": 1247,
														"name": "Identifier",
														"src": "3690:12:4"
													}
												],
												"id": 1248,
												"name": "FunctionCall",
												"src": "3667:36:4"
											}
										],
										"id": 1249,
										"name": "ExpressionStatement",
										"src": "3667:36:4"
									}
								],
								"id": 1250,
								"name": "Block",
								"src": "3467:244:4"
							}
						],
						"id": 1251,
						"name": "FunctionDefinition",
						"src": "3393:318:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "freezeAccount",
							"payable": false,
							"scope": 1382,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "target",
											"scope": 1281,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1252,
												"name": "ElementaryTypeName",
												"src": "3935:7:4"
											}
										],
										"id": 1253,
										"name": "VariableDeclaration",
										"src": "3935:14:4"
									},
									{
										"attributes": {
											"constant": false,
											"name": "freeze",
											"scope": 1281,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bool",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bool",
													"type": "bool"
												},
												"id": 1254,
												"name": "ElementaryTypeName",
												"src": "3951:4:4"
											}
										],
										"id": 1255,
										"name": "VariableDeclaration",
										"src": "3951:11:4"
									}
								],
								"id": 1256,
								"name": "ParameterList",
								"src": "3934:29:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1259,
								"name": "ParameterList",
								"src": "3981:0:4"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1069,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 1257,
										"name": "Identifier",
										"src": "3964:9:4"
									}
								],
								"id": 1258,
								"name": "ModifierInvocation",
								"src": "3964:9:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1260,
														"name": "Identifier",
														"src": "3992:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "!=",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "uint256",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getCitizen",
																			"referencedDeclaration": 1016,
																			"type": "function (address) view external returns (uint256)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1034,
																					"type": "contract Citizens",
																					"value": "sharesCitizensAddress"
																				},
																				"id": 1261,
																				"name": "Identifier",
																				"src": "4000:21:4"
																			}
																		],
																		"id": 1262,
																		"name": "MemberAccess",
																		"src": "4000:32:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1253,
																			"type": "address",
																			"value": "target"
																		},
																		"id": 1263,
																		"name": "Identifier",
																		"src": "4033:6:4"
																	}
																],
																"id": 1264,
																"name": "FunctionCall",
																"src": "4000:40:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"hexvalue": "30",
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"subdenomination": null,
																	"token": "number",
																	"type": "int_const 0",
																	"value": "0"
																},
																"id": 1265,
																"name": "Literal",
																"src": "4044:1:4"
															}
														],
														"id": 1266,
														"name": "BinaryOperation",
														"src": "4000:45:4"
													}
												],
												"id": 1267,
												"name": "FunctionCall",
												"src": "3992:54:4"
											}
										],
										"id": 1268,
										"name": "ExpressionStatement",
										"src": "3992:54:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1038,
																	"type": "mapping(address => bool)",
																	"value": "frozenAccount"
																},
																"id": 1269,
																"name": "Identifier",
																"src": "4057:13:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1253,
																	"type": "address",
																	"value": "target"
																},
																"id": 1270,
																"name": "Identifier",
																"src": "4071:6:4"
															}
														],
														"id": 1271,
														"name": "IndexAccess",
														"src": "4057:21:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1255,
															"type": "bool",
															"value": "freeze"
														},
														"id": 1272,
														"name": "Identifier",
														"src": "4081:6:4"
													}
												],
												"id": 1273,
												"name": "Assignment",
												"src": "4057:30:4"
											}
										],
										"id": 1274,
										"name": "ExpressionStatement",
										"src": "4057:30:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1056,
															"type": "function (address,bool)",
															"value": "FrozenFunds"
														},
														"id": 1275,
														"name": "Identifier",
														"src": "4098:11:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1253,
															"type": "address",
															"value": "target"
														},
														"id": 1276,
														"name": "Identifier",
														"src": "4110:6:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1255,
															"type": "bool",
															"value": "freeze"
														},
														"id": 1277,
														"name": "Identifier",
														"src": "4118:6:4"
													}
												],
												"id": 1278,
												"name": "FunctionCall",
												"src": "4098:27:4"
											}
										],
										"id": 1279,
										"name": "ExpressionStatement",
										"src": "4098:27:4"
									}
								],
								"id": 1280,
								"name": "Block",
								"src": "3981:152:4"
							}
						],
						"id": 1281,
						"name": "FunctionDefinition",
						"src": "3912:221:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "setPrices",
							"payable": false,
							"scope": 1382,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "newSellPrice",
											"scope": 1301,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1282,
												"name": "ElementaryTypeName",
												"src": "4350:7:4"
											}
										],
										"id": 1283,
										"name": "VariableDeclaration",
										"src": "4350:20:4"
									}
								],
								"id": 1284,
								"name": "ParameterList",
								"src": "4349:22:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1287,
								"name": "ParameterList",
								"src": "4389:0:4"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1069,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 1285,
										"name": "Identifier",
										"src": "4372:9:4"
									}
								],
								"id": 1286,
								"name": "ModifierInvocation",
								"src": "4372:9:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1028,
															"type": "uint256",
															"value": "sellPrice"
														},
														"id": 1288,
														"name": "Identifier",
														"src": "4400:9:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1283,
															"type": "uint256",
															"value": "newSellPrice"
														},
														"id": 1289,
														"name": "Identifier",
														"src": "4412:12:4"
													}
												],
												"id": 1290,
												"name": "Assignment",
												"src": "4400:24:4"
											}
										],
										"id": 1291,
										"name": "ExpressionStatement",
										"src": "4400:24:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1030,
															"type": "uint256",
															"value": "buyPrice"
														},
														"id": 1292,
														"name": "Identifier",
														"src": "4435:8:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "+",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1028,
																	"type": "uint256",
																	"value": "sellPrice"
																},
																"id": 1293,
																"name": "Identifier",
																"src": "4446:9:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "/",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1028,
																			"type": "uint256",
																			"value": "sellPrice"
																		},
																		"id": 1294,
																		"name": "Identifier",
																		"src": "4458:9:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "35",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 5",
																			"value": "5"
																		},
																		"id": 1295,
																		"name": "Literal",
																		"src": "4470:1:4"
																	}
																],
																"id": 1296,
																"name": "BinaryOperation",
																"src": "4458:13:4"
															}
														],
														"id": 1297,
														"name": "BinaryOperation",
														"src": "4446:25:4"
													}
												],
												"id": 1298,
												"name": "Assignment",
												"src": "4435:36:4"
											}
										],
										"id": 1299,
										"name": "ExpressionStatement",
										"src": "4435:36:4"
									}
								],
								"id": 1300,
								"name": "Block",
								"src": "4389:90:4"
							}
						],
						"id": 1301,
						"name": "FunctionDefinition",
						"src": "4331:148:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "buy",
							"payable": true,
							"scope": 1382,
							"stateMutability": "payable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1302,
								"name": "ParameterList",
								"src": "4576:2:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1305,
								"name": "ParameterList",
								"src": "4604:0:4"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1083,
											"type": "modifier ()",
											"value": "isCitizen"
										},
										"id": 1303,
										"name": "Identifier",
										"src": "4587:9:4"
									}
								],
								"id": 1304,
								"name": "ModifierInvocation",
								"src": "4587:9:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1306,
														"name": "Identifier",
														"src": "4615:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "<",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1042,
																					"type": "mapping(address => uint256)",
																					"value": "balanceOf"
																				},
																				"id": 1307,
																				"name": "Identifier",
																				"src": "4623:9:4"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1394,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 1308,
																						"name": "Identifier",
																						"src": "4633:3:4"
																					}
																				],
																				"id": 1309,
																				"name": "MemberAccess",
																				"src": "4633:10:4"
																			}
																		],
																		"id": 1310,
																		"name": "IndexAccess",
																		"src": "4623:21:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "31",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 1",
																			"value": "1"
																		},
																		"id": 1311,
																		"name": "Literal",
																		"src": "4647:1:4"
																	}
																],
																"id": 1312,
																"name": "BinaryOperation",
																"src": "4623:25:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "==",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "value",
																			"referencedDeclaration": null,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1394,
																					"type": "msg",
																					"value": "msg"
																				},
																				"id": 1313,
																				"name": "Identifier",
																				"src": "4665:3:4"
																			}
																		],
																		"id": 1314,
																		"name": "MemberAccess",
																		"src": "4665:9:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1030,
																			"type": "uint256",
																			"value": "buyPrice"
																		},
																		"id": 1315,
																		"name": "Identifier",
																		"src": "4678:8:4"
																	}
																],
																"id": 1316,
																"name": "BinaryOperation",
																"src": "4665:21:4"
															}
														],
														"id": 1317,
														"name": "BinaryOperation",
														"src": "4623:63:4"
													}
												],
												"id": 1318,
												"name": "FunctionCall",
												"src": "4615:72:4"
											}
										],
										"id": 1319,
										"name": "ExpressionStatement",
										"src": "4615:72:4"
									},
									{
										"attributes": {
											"assignments": [
												1321
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "commission",
													"scope": 1344,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint",
															"type": "uint256"
														},
														"id": 1320,
														"name": "ElementaryTypeName",
														"src": "4698:4:4"
													}
												],
												"id": 1321,
												"name": "VariableDeclaration",
												"src": "4698:15:4"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "-",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1030,
															"type": "uint256",
															"value": "buyPrice"
														},
														"id": 1322,
														"name": "Identifier",
														"src": "4716:8:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1028,
															"type": "uint256",
															"value": "sellPrice"
														},
														"id": 1323,
														"name": "Identifier",
														"src": "4727:9:4"
													}
												],
												"id": 1324,
												"name": "BinaryOperation",
												"src": "4716:20:4"
											}
										],
										"id": 1325,
										"name": "VariableDeclarationStatement",
										"src": "4698:38:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1194,
															"type": "function (address,address,uint256)",
															"value": "_transfer"
														},
														"id": 1326,
														"name": "Identifier",
														"src": "4747:9:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"arguments": [
																null
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "address",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "getOwner",
																	"referencedDeclaration": 1008,
																	"type": "function () view external returns (address)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1032,
																			"type": "contract Owned",
																			"value": "sharesOwnedAddress"
																		},
																		"id": 1327,
																		"name": "Identifier",
																		"src": "4757:18:4"
																	}
																],
																"id": 1328,
																"name": "MemberAccess",
																"src": "4757:27:4"
															}
														],
														"id": 1329,
														"name": "FunctionCall",
														"src": "4757:29:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1394,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1330,
																"name": "Identifier",
																"src": "4788:3:4"
															}
														],
														"id": 1331,
														"name": "MemberAccess",
														"src": "4788:10:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "31",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 1",
															"value": "1"
														},
														"id": 1332,
														"name": "Literal",
														"src": "4800:1:4"
													}
												],
												"id": 1333,
												"name": "FunctionCall",
												"src": "4747:55:4"
											}
										],
										"id": 1334,
										"name": "ExpressionStatement",
										"src": "4747:55:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "transfer",
															"referencedDeclaration": null,
															"type": "function (uint256)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"arguments": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "address",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				null
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "getOwner",
																			"referencedDeclaration": 1008,
																			"type": "function () view external returns (address)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1032,
																					"type": "contract Owned",
																					"value": "sharesOwnedAddress"
																				},
																				"id": 1335,
																				"name": "Identifier",
																				"src": "4849:18:4"
																			}
																		],
																		"id": 1337,
																		"name": "MemberAccess",
																		"src": "4849:27:4"
																	}
																],
																"id": 1338,
																"name": "FunctionCall",
																"src": "4849:29:4"
															}
														],
														"id": 1339,
														"name": "MemberAccess",
														"src": "4849:38:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1321,
															"type": "uint256",
															"value": "commission"
														},
														"id": 1340,
														"name": "Identifier",
														"src": "4888:10:4"
													}
												],
												"id": 1341,
												"name": "FunctionCall",
												"src": "4849:50:4"
											}
										],
										"id": 1342,
										"name": "ExpressionStatement",
										"src": "4849:50:4"
									}
								],
								"id": 1343,
								"name": "Block",
								"src": "4604:303:4"
							}
						],
						"id": 1344,
						"name": "FunctionDefinition",
						"src": "4564:343:4"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "sell",
							"payable": false,
							"scope": 1382,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1345,
								"name": "ParameterList",
								"src": "4996:2:4"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1348,
								"name": "ParameterList",
								"src": "5016:0:4"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1083,
											"type": "modifier ()",
											"value": "isCitizen"
										},
										"id": 1346,
										"name": "Identifier",
										"src": "4999:9:4"
									}
								],
								"id": 1347,
								"name": "ModifierInvocation",
								"src": "4999:9:4"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1397,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1349,
														"name": "Identifier",
														"src": "5021:7:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "==",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1042,
																					"type": "mapping(address => uint256)",
																					"value": "balanceOf"
																				},
																				"id": 1350,
																				"name": "Identifier",
																				"src": "5029:9:4"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1394,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 1351,
																						"name": "Identifier",
																						"src": "5039:3:4"
																					}
																				],
																				"id": 1352,
																				"name": "MemberAccess",
																				"src": "5039:10:4"
																			}
																		],
																		"id": 1353,
																		"name": "IndexAccess",
																		"src": "5029:21:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "31",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 1",
																			"value": "1"
																		},
																		"id": 1354,
																		"name": "Literal",
																		"src": "5054:1:4"
																	}
																],
																"id": 1355,
																"name": "BinaryOperation",
																"src": "5029:26:4"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": ">=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "balance",
																			"referencedDeclaration": null,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1425,
																					"type": "contract Token",
																					"value": "this"
																				},
																				"id": 1356,
																				"name": "Identifier",
																				"src": "5066:4:4"
																			}
																		],
																		"id": 1357,
																		"name": "MemberAccess",
																		"src": "5066:12:4"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1028,
																			"type": "uint256",
																			"value": "sellPrice"
																		},
																		"id": 1358,
																		"name": "Identifier",
																		"src": "5082:9:4"
																	}
																],
																"id": 1359,
																"name": "BinaryOperation",
																"src": "5066:25:4"
															}
														],
														"id": 1360,
														"name": "BinaryOperation",
														"src": "5029:62:4"
													}
												],
												"id": 1361,
												"name": "FunctionCall",
												"src": "5021:71:4"
											}
										],
										"id": 1362,
										"name": "ExpressionStatement",
										"src": "5021:71:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1194,
															"type": "function (address,address,uint256)",
															"value": "_transfer"
														},
														"id": 1363,
														"name": "Identifier",
														"src": "5160:9:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1394,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1364,
																"name": "Identifier",
																"src": "5170:3:4"
															}
														],
														"id": 1365,
														"name": "MemberAccess",
														"src": "5170:10:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"arguments": [
																null
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "address",
															"type_conversion": false
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		null
																	],
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "getOwner",
																	"referencedDeclaration": 1008,
																	"type": "function () view external returns (address)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1032,
																			"type": "contract Owned",
																			"value": "sharesOwnedAddress"
																		},
																		"id": 1366,
																		"name": "Identifier",
																		"src": "5182:18:4"
																	}
																],
																"id": 1367,
																"name": "MemberAccess",
																"src": "5182:27:4"
															}
														],
														"id": 1368,
														"name": "FunctionCall",
														"src": "5182:29:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "31",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 1",
															"value": "1"
														},
														"id": 1369,
														"name": "Literal",
														"src": "5213:1:4"
													}
												],
												"id": 1370,
												"name": "FunctionCall",
												"src": "5160:55:4"
											}
										],
										"id": 1371,
										"name": "ExpressionStatement",
										"src": "5160:55:4"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "transfer",
															"referencedDeclaration": null,
															"type": "function (uint256)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1394,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1372,
																		"name": "Identifier",
																		"src": "5252:3:4"
																	}
																],
																"id": 1375,
																"name": "MemberAccess",
																"src": "5252:10:4"
															}
														],
														"id": 1376,
														"name": "MemberAccess",
														"src": "5252:19:4"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1028,
															"type": "uint256",
															"value": "sellPrice"
														},
														"id": 1377,
														"name": "Identifier",
														"src": "5272:9:4"
													}
												],
												"id": 1378,
												"name": "FunctionCall",
												"src": "5252:30:4"
											}
										],
										"id": 1379,
										"name": "ExpressionStatement",
										"src": "5252:30:4"
									}
								],
								"id": 1380,
								"name": "Block",
								"src": "5016:371:4"
							}
						],
						"id": 1381,
						"name": "FunctionDefinition",
						"src": "4983:404:4"
					}
				],
				"id": 1382,
				"name": "ContractDefinition",
				"src": "241:5155:4"
			}
		],
		"id": 1383,
		"name": "SourceUnit",
		"src": "0:5396:4"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.19+commit.c4cbbb05.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0xb9ab8d9fddfc24ab0e94480c96b7e72715caa3ae"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-03-13T19:12:19.994Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Token.json
// module id = 157
// module chunks = 0